import React from 'react';
import AbstractRequestTask from '../AbstractRequestTask';

class PaywayListPaymentMethodTask  extends AbstractRequestTask {

    constructor(config) {
        super();
        this.config = config;
    }

    getUrl() {
        const domain = this.config.url_dominio_microfwk;
        
        return `${domain}services/payway/listpaymentmethod`
    }

    getParams() {
        let params = super.getParams(this.config);
        this.params = Object.assign(params, this.params);

        return params;
    }

    success(data, b) {
        let isValid = super.success(data, b);
        if (!isValid) {
            let newData = super.parseErrors(data);
            return this.reject(newData, b);
        }
        this.resolve(data);
    }

}

export default PaywayListPaymentMethodTask;